module.exports = __webpack_public_path__ + "static/shibon-cover-3cd08adaf89c37304abbf23f16ee9fec.png";